import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { TABLE_ROWS_PER_PAGE, TABLE_DATE_FORMAT } from "../../../../utils/Constants";
import { RenderLearningMethod } from "../../../../utils/CommonGroupingItem";
import { RenderMatchStatus } from "../../../../utils/CommonStatusItems";
import DataTable from "react-data-table-component";
import SkeletonTicketList from "../../../../loaders/SkeletonTicketList";
import PermissionsGate from "../../../../utils/permissionGate";
import moment from "moment";

const safeToString = (v) => (v === null || v === undefined ? "" : v.toString());

const getLearningMethodLabel = (typeValue) => {
  const rendered = RenderLearningMethod(typeValue);
  if (rendered && typeof rendered === "object" && rendered.label) return rendered.label;
  return typeValue ?? "Unknown";
};

const getMismatchTooltip = (row) => {
  const qualificationLabel = getLearningMethodLabel(row?.qualificationLearningMethod);
  const courseLabel = getLearningMethodLabel(row?.Type);
  return `Learning method mismatch.`;
};

const MatchedCoursesTable = ({ courses, qualOption }) => {
  // Helper to get label from the qualOption array (passed as prop)
  const getQualLabel = (netsuiteId) => {
    const option = qualOption.find(
      (o) => safeToString(o.value) === safeToString(netsuiteId)
    );
    return option ? option.label : "Netsuite Product not Found";
  };
  
  // Column definitions (using useMemo for optimization)
  const columns = useMemo(() => [
    {
      name: "Course",
      selector: "Name",
      sortable: true,
      cell: row => {
        if (!row.intakeId) return <strong>{getQualLabel(row.NetsuiteId)}</strong>;
        
        return (
          <Link
            to={`/courseAdministration/coursesdetails/${row.intakeId}/detailCourses/show`}
            className="as-text-blue textLimit50"
            title={row.Name}
          >
            {row.Name}
          </Link>
        );
      }
    },
    {
      name: "Status",
      selector: "Status",
      cell: row => RenderMatchStatus(row.Status).html
    },
    {
      name: "Netsuite ID",
      selector: "NetsuiteId",
      cell: row => <span className="titleTextLimit30">{row.NetsuiteId}</span>
    },
    {
      name: "Intake",
      selector: "Intake",
      cell: row => <span className="titleTextLimit50">{row.Intake}</span>
    },
    {
      name: "Start",
      selector: "StartDate",
      cell: row => <div className="">
      {row.Start != "-" ? <>
      <p className="right-space">
        {moment.unix(row.Start).format(TABLE_DATE_FORMAT)}
        </p>
      </> : <span>"-"</span>
      }
      </div>
    },
    {
      name: "End",
      selector: "EndDate",
      cell: row => <div className="">
      {row.End != "-" ? <>
      <p className="right-space">
        {moment.unix(row.End).format(TABLE_DATE_FORMAT)}
        </p>
      </> : <span>"-"</span>
      }
      </div>
    },
    {
      name: "Learning Method",
      selector: "Type",
      cell: row => {
        const showWarning = row.learningMethodMismatch === true;
        
        return (
          <div className="d-flex align-items-center">
            {RenderLearningMethod(row.Type).html}
            
            {showWarning && (
              <i
                className="fal fa-exclamation-triangle ml-2 text-danger"
                title={getMismatchTooltip(row)}
                style={{ cursor: "help" }}
              />
            )}
          </div>
        );
      }
    },
    {
      name: "Actions",
      cell: row => (
        <div className="assessment-08 btn-dropdown-grp">
        <div className="as-buttons">
        {row.intakeId ? (
          <PermissionsGate
          scopes={["cview"]}
          RenderError={() => (
            <button className="btn btn-primary rounded-circle" title="Open" disabled>
            <i className="fal fa-folder-open"></i>
            </button>
          )}
          >
          <Link
          to={`/courseAdministration/coursesdetails/${row.intakeId}/detailCourses/show`}
          className="btn btn-primary rounded-circle"
          title="Open"
          >
          <i className="fal fa-folder-open"></i>
          </Link>
          </PermissionsGate>
        ) : (
          <button className="btn btn-primary rounded-circle" title="Open" disabled>
          <i className="fal fa-folder-open"></i>
          </button>
        )}
        </div>
        </div>
      )
    }
  ], [courses, qualOption]);
  
  return (
    <div className="l-o-c-t custom-table-div filter-search-icon card card-table-custom days-overdue-cell-width">
    <div className="card-header">Matched Courses</div>
    <DataTable
    data={courses}
    defaultSortField="Name"
    defaultSortAsc
    columns={columns}
    pagination
    paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
    progressComponent={<SkeletonTicketList />}
    progressPending={false}
    />
    </div>
  );
};

export default MatchedCoursesTable;
